/*!
 * ElitePelletsKopen - Productpagina postcode-zonecheck (v8)
 * Postcode VERPLICHT bij bezorgen, VRIJ bij afhalen. Werkt ook in quick-view/quick-add.
 * v7: specifieke zone bij postcode -> losse "Bezorgen" verborgen. Globaal geladen + init-guard.
 * v8: postcode-UI VOLLEDIG verborgen bij Hoeveelheid "1 zak" of "10 zakken" (alleen afhalen). Afhalen blijft geselecteerd.
 * (8860 toegevoegd aan zone 2.)
 * v9/v10: Waddeneilanden (Texel 1791-1797, Vlieland 8899, Terschelling 8880-8897, Ameland 9163-9164, Schiermonnikoog 9166).
 *     Bezorging gaat naar een plaats op het vasteland; de zone (prijs) is de bestaande vasteland-zone van die plaats.
 *     Op de productpagina wordt het zone-label hernoemd naar "Bezorgen naar <Plaats>"; bij meerdere plaatsen kiest de klant.
 *     Originele labels worden hersteld voor vasteland-postcodes.
 * v12: CONTACT-zones (o.a. Zeeuws-Vlaanderen 4500-4599): geen online bezorging, bezorgopties verborgen + bel/mail-melding. Afhalen blijft mogelijk.
 * v14: Wadden-terugval: heeft een product geen zone-variant die bij de eiland-plaats past (bv. Rood/EuroWood), dan wordt de
 *      algemene "Bezorgen"-variant getoond en hernoemd naar "Bezorgen naar <plaats(en)>", zodat eilandklanten tóch kunnen bestellen.
 * v15: (teruggedraaid) Levering-blok is weer altijd zichtbaar; Afhalen blijft altijd te zien.
 * v42 (2026-10-16): postcode 9271 (De Westereen) van ring 3 naar ring 2 (15-30 km, ca. 25 km).
 * v41 (2026-10-14): postcodes 9082, 9087 en 9089 van ring 3 naar ring 2 (15-30 km, ca. 17-18 km).
 * v40 (2026-10-14): postcode 9088 (Wirdum) van ring 3 naar ring 2 (15-30 km).
 * v39 (2026-10-08): bij "Laten bezorgen" met postcode wordt de enige bezorgoptie ALTIJD vanzelf gekozen. Werd een herselectie
 *      overgeslagen omdat het thema net aan het hertekenen was (applying), dan volgt nu een nieuwe poging; en staat er na afloop toch
 *      geen zichtbare bezorgoptie gekozen terwijl er precies één is, dan wordt die alsnog gekozen (geen handmatige tik meer nodig).
 * v38 (2026-10-03): staat de knop op "Vul eerst je postcode in", dan brengt een tik op de knop (ook in de vaste balk) de klant naar het
 *      postcodeveld. De knop is dan niet meer echt uitgeschakeld maar aria-disabled (zelfde uiterlijk; het thema bestelt dan niet).
 * v37 (2026-10-03): foto van het gekozen aantal direct tonen, ook zonder postcode (de gekozen combinatie bestaat dan nog niet,
 *      dus het thema wisselt de foto niet zelf). Neemt de foto van een bezorgvariant van dat aantal.
 * v36 (2026-10-03): eerst kiezen "Afhalen in Menaam" of "Laten bezorgen" (blok boven de aantallen); die keuze bepaalt welke
 *      aantallen zichtbaar zijn (was: het aantal bepaalde de leveropties). Varianten, zones en postcodelogica ongewijzigd.
 *      Bezorgen zonder (geldige) bezorgoptie: knop uit met "Vul eerst je postcode in"; Afhalen blijft altijd kiesbaar via het blok.
 * v35 (2026-10-02): aantal dat alleen bezorgd wordt (35/50/60 zakken) zonder postcode: knop "Vul eerst je postcode in" i.p.v.
 *      "Niet beschikbaar", oranje rand om het postcodeveld en alvast de prijs van dat aantal. Hinttekst ingekort.
 * v34 (2026-10-02): label postcodeveld "Vul hier je postcode in (voor bezorging)".
 * v33 (2026-09-28): postcode 8938 (Leeuwarden) naar ring 1 (tot 15 km).
 * v32 (2026-09-28): postcode 8938 (Leeuwarden) van ring 3 naar ring 2 (15-30 km).
 * v31 (2026-09-16): bezorgzin onder de prijs alleen zichtbaar bij gekozen bezorgoptie (span.epk-bezorgtekst in .product__tax).
 * v30 (2026-09-16): aantallen zonder bezorgvariant (70 zakken) gedragen zich als 1/10 zakken: alleen afhalen, geen postcodeveld.
 * v29 (2026-09-10): ook op een volgend product met onthouden postcode: zodra de klant een bezorgbaar aantal kiest, wordt de
 *      bezorgoptie automatisch gekozen. Nooit bij het laden van de pagina (pas na een eigen handeling), één keer per postcode per pagina.
 * v28 (2026-09-10): na volledige postcode wordt de enige zichtbare bezorgoptie automatisch gekozen (zie autoSelectBezorgen).
 * v27 (2026-09-10): Sneek 8602-8606 van ring 3 naar ring 2 (15-30 km); 8607/8608 blijven ring 3. 8601 stond al in ring 2.
 * v26: Refresh-renders worden SYNCHROON in de MutationObserver verwerkt (geen 120 ms-flits van ongefilterde zones + doorgestreepte "Bezorgen");
 *      radio's in de oude, verborgen variant-selects (Refresh double buffer, 500 ms) worden genegeerd.
 * v25: bij "1 zak"/"10 zakken" wordt Afhalen vooraf (capture) aangeklikt -> geen "Niet beschikbaar"-flits meer. Sprong-naar-boven zat in media-gallery.js (variant-afbeeldingen), daar opgelost.
 * v24: radio in product-info verliest focus direct bij change (capture), zodat Refresh nooit een gefocust element verwijdert.
 * v23: GEEN eigen scroll meer (terug-scroll na autofill verwijderd); radio-focus in product-info krijgt preventScroll (iOS-sprong bij variantwissel).
 * v21: iOS-suggestie BEHOUDEN (autocomplete="section-epk postal-code" in eigen mini-form #epk-pc-form); na autofill (>=3 cijfers in 1 keer) scrollt de pagina terug naar het postcodeveld.
 * v19: postcode-input font-size 16px (voorkomt iOS-inzoomen bij focus).
 * v18: de KOPREGEL van het Levering-blok is VERBORGEN zolang er geen afstands-opties te kiezen zijn (geen postcode,
 *      afhaal-only aantal, contact-zone of eiland); alleen dan verschijnt "Levering (kies de afstand tot Menaam)". Afhalen-knop blijft altijd zichtbaar.
 */
(function () {
  "use strict";
  if (window.__epkPostcodeInit) return;
  window.__epkPostcodeInit = true;
  /* iOS: Refresh vervangt bij een variantwissel de radio en roept focus() op de nieuwe aan; Safari scrolt dan soms naar boven.
     Radio-focus binnen product-info krijgt daarom altijd preventScroll:true. */
  try{
    var __of=HTMLElement.prototype.focus;
    HTMLElement.prototype.focus=function(opt){
      if(this && this.type==="radio" && this.closest && this.closest("product-info")){ opt=Object.assign({},opt||{},{preventScroll:true}); }
      return __of.call(this,opt);
    };
  }catch(e){}
  /* v25: kiest de klant "1 zak"/"10 zakken" terwijl een bezorgoptie actief is, dan wordt Afhalen hier (capture, voor Refresh)
     aangeklikt. Refresh haalt dan meteen de geldige combinatie op en toont nooit kort "Niet beschikbaar". */
  document.addEventListener("change",function(e){
    var t=e.target; if(!t || t.type!=="radio" || !t.closest || !t.closest("product-info") || isStale(t)) return;
    if((t.name||"").indexOf("Hoeveelheid")===-1) return;
    var v=(t.value||"").trim(); if(v!=="1 zak" && v!=="10 zakken") return;
    var lev=[].slice.call(t.closest("product-info").querySelectorAll('input[type="radio"][name*="Levering"]'));
    var cur=lev.filter(function(r){return r.checked;})[0];
    if(cur && (cur.value||"").toLowerCase().indexOf("afhalen")!==-1) return;
    var af=lev.filter(function(r){return (r.value||"").toLowerCase().indexOf("afhalen")!==-1;})[0];
    if(af && !af.checked){ try{ af.click(); }catch(err){} }
  },true);
  /* iOS: voorkom dat een radio met focus wordt verwijderd bij de variantwissel -> focus meteen loslaten. */
  document.addEventListener("change",function(e){
    var t=e.target; if(t && t.type==="radio" && t.closest && t.closest("product-info") && document.activeElement===t){ try{ t.blur(); }catch(err){} }
  },true);
  var RING1 = ["8634","8636","8637","8731","8732","8733","8801","8802","8803","8804","8805","8806","8807","8808","8809","8811","8812","8813","8814","8816","8831","8832","8833","8834","8835","8841","8842","8843","8844","8851","8852","8853","8854","8855","8856","8857","8871","8901","8902","8903","8911","8912","8913","8914","8915","8916","8917","8918","8919","8920","8921","8922","8923","8924","8925","8926","8927","8931","8932","8933","8934","8935","8936","8938","8939","8941","9023","9024","9025","9026","9027","9031","9032","9033","9034","9035","9036","9037","9038","9041","9043","9044","9045","9047","9051","9053","9054","9055","9056","9057","9071","9072","9074","9075","9076","9077","9078","9079","9081","9083","9084","9085","9086"];
  var RING2 = ["8491","8493","8494","8495","8497","8514","8601","8602","8603","8604","8605","8606","8614","8626","8627","8628","8629","8632","8633","8635","8641","8642","8647","8701","8734","8735","8736","8737","8741","8742","8743","8744","8745","8747","8748","8749","8751","8771","8773","8821","8822","8823","8860","8861","8862","8872","9001","9003","9005","9007","9008","9009","9011","9012","9013","9014","9022","9061","9062","9063","9064","9067","9073","9082","9087","9088","9089","9105","9107","9112","9133","9151","9152","9153","9154","9155","9156","9171","9172","9173","9175","9176","9177","9178","9215","9217","9219","9245","9248","9251","9254","9255","9256","9257","9262","9263","9264","9265","9269","9271"];
  var R1 = new Set(RING1), R2 = new Set(RING2);
  var WADDEN = [
    {naam:"Texel", van:1791, tot:1797, via:[{plaats:"Den Helder", ring:3}]},
    {naam:"Vlieland", van:8899, tot:8899, via:[{plaats:"Leeuwarden", ring:1}]},
    {naam:"Terschelling", van:8880, tot:8897, via:[{plaats:"Leeuwarden", ring:1}]},
    {naam:"Ameland", van:9163, tot:9164, via:[{plaats:"Leeuwarden", ring:1},{plaats:"Holwerd", ring:2}]},
    {naam:"Schiermonnikoog", van:9166, tot:9166, via:[{plaats:"Leeuwarden", ring:1},{plaats:"Holwerd", ring:2}]}
  ];
  function waddenOf(pc4){ var n=parseInt(pc4,10); if(!n) return null; for(var i=0;i<WADDEN.length;i++){ if(n>=WADDEN[i].van && n<=WADDEN[i].tot) return WADDEN[i]; } return null; }
  var CONTACT = [
    {naam:"Zeeuws-Vlaanderen", van:4500, tot:4599}
  ];
  function contactOf(pc4){ var n=parseInt(pc4,10); if(!n) return null; for(var i=0;i<CONTACT.length;i++){ if(n>=CONTACT[i].van && n<=CONTACT[i].tot) return CONTACT[i]; } return null; }
  function isStale(el){ var vs=el&&el.closest?el.closest("variant-selects"):null; return !!(vs && vs.style.display==="none"); }
  function labelTextNode(l){ for(var i=0;i<l.childNodes.length;i++){ var n=l.childNodes[i]; if(n.nodeType===3 && n.textContent.trim()) return n; } return null; }
  function relabel(x, text){
    if(x.kind==="option"){ if(!x.el.dataset.epkOrig) x.el.dataset.epkOrig=x.el.textContent; x.el.textContent=text; return; }
    var l=labelOf(x); if(!l||l.contains(x.el)) return;
    var tn=labelTextNode(l);
    if(tn){ if(!l.dataset.epkOrig) l.dataset.epkOrig=tn.textContent; tn.textContent=text; }
    else { if(!l.dataset.epkOrig) l.dataset.epkOrig=l.textContent; l.textContent=text; }
  }
  function restoreLabel(x){
    if(x.kind==="option"){ if(x.el.dataset.epkOrig) x.el.textContent=x.el.dataset.epkOrig; return; }
    var l=labelOf(x); if(!l||!l.dataset.epkOrig) return;
    var tn=labelTextNode(l);
    if(tn) tn.textContent=l.dataset.epkOrig; else l.textContent=l.dataset.epkOrig;
  }

  var savedPc = "";
  try { savedPc = (sessionStorage.getItem("epkPc") || "").replace(/[^0-9]/g, "").slice(0, 4); } catch (e) {}
  function setSavedPc(v){ savedPc=(v||"").replace(/[^0-9]/g,"").slice(0,4); try{ sessionStorage.setItem("epkPc", savedPc); }catch(e){} }

  function ringOf(pc4){ return R1.has(pc4)?1:R2.has(pc4)?2:3; }
  function isSpecificZone(v){
    v=(v||"").toLowerCase();
    return v.indexOf("tot 15")!==-1||v.indexOf("15-30")!==-1||v.indexOf("15 en 30")!==-1||v.indexOf("boven 30")!==-1||v.indexOf("boven 15")!==-1;
  }
  function isAllowed(val, r){
    var v=(val||"").toLowerCase();
    if(v.indexOf("afhalen")!==-1) return true;
    if(v.indexOf("bezorgen")===-1) return true;
    if(v.indexOf("tot 15")!==-1) return r===1;
    if(v.indexOf("15-30")!==-1||v.indexOf("15 en 30")!==-1) return r===2;
    if(v.indexOf("boven 30")!==-1) return r===3;
    if(v.indexOf("boven 15")!==-1) return r!==1;
    return true;
  }
  function isDelivery(v){ v=(v||"").toLowerCase(); return v.indexOf("bezorgen")!==-1||v.indexOf("afhalen")!==-1; }
  function isBezorg(v){ return (v||"").toLowerCase().indexOf("bezorgen")!==-1; }

  function selectedHoeveelheid(){
    var rs=document.querySelectorAll('input[type="radio"][name*="Hoeveelheid"]:checked');
    for(var i=0;i<rs.length;i++){ if(!isStale(rs[i])) return (rs[i].value||"").trim(); }
    return "";
  }
  /* v30 (2026-09-16): ook "alleen afhalen" als er voor het gekozen aantal geen enkele bezorgvariant bestaat (bv. 70 zakken):
     dan geen postcodeveld en geen bezorgtekst, net als bij 1 zak/10 zakken. */
  function isPickupOnlyQty(){
    var v=selectedHoeveelheid(); if(v==="1 zak"||v==="10 zakken") return true;
    var els=deliveryEls().filter(function(x){ return x.kind==="radio"; });
    if(!els.length) return false;
    for(var i=0;i<els.length;i++){ if(isBezorg(els[i].val) && !qtyDisabled(els[i])) return false; }
    return true;
  }

  function getForm(){ return document.querySelector('form[action*="/cart/add"]'); }
  function pcValue(){ return savedPc; }

  function deliveryEls(){
    var out=[];
    document.querySelectorAll('input[type="radio"]').forEach(function(i){ if(isDelivery(i.value) && !isStale(i)) out.push({kind:"radio",el:i,val:i.value}); });
    document.querySelectorAll("select option").forEach(function(o){ if(isDelivery(o.value)) out.push({kind:"option",el:o,val:o.value}); });
    return out;
  }
  function qtyDisabled(x){ return x.kind==="radio" ? x.el.classList.contains("disabled") : !!x.el.disabled; }
  function labelOf(x){ return document.querySelector('label[for="'+x.el.id+'"]') || (x.el.closest?x.el.closest("label"):null); }
  function setVisible(x, on){
    if(x.kind==="radio"){ var l=labelOf(x); if(l) l.style.display=on?"":"none"; x.el.style.display=on?"":"none"; }
    else { x.el.style.display=on?"":"none"; if(!on) x.el.disabled=true; }
  }
  function isSelected(x){ return x.kind==="radio"?x.el.checked:x.el.selected; }
  function selectEl(x){
    selCount++;
    if(x.kind==="radio"){ x.el.checked=true; x.el.dispatchEvent(new Event("change",{bubbles:true})); }
    else { var s=x.el.parentElement; s.value=x.el.value; s.dispatchEvent(new Event("change",{bubbles:true})); }
  }

  var applying=false;
  function apply(){
    if(!getForm()) return;
    var pc=pcValue(), hasPc=pc.length>=4, r=hasPc?ringOf(pc):0;
    var wadden = hasPc ? waddenOf(pc) : null;
    var contact = hasPc ? contactOf(pc) : null;
    var msg=document.getElementById("epk-postcode-msg");
    var els=deliveryEls(), afhalen=null, needReselect=false, shownBezorg=[];
    /* v36 */
    var useMode=ensureModeUI(els), bezMode=useMode&&mode==="bezorgen", afhMode=useMode&&mode==="afhalen";
    if(useMode){ filterQty(); if(!applying && fixQty()) return; }
    var hasSpecificZone = hasPc && els.some(function(x){ return isBezorg(x.val)&&isSpecificZone(x.val)&&!qtyDisabled(x)&&isAllowed(x.val,r); });
    var wUnmatched=[];
    if(wadden){
      var wMatched=wadden.via.map(function(){return false;});
      els.forEach(function(x){
        if(!isBezorg(x.val)||!isSpecificZone(x.val)||qtyDisabled(x)) return;
        for(var k=0;k<wadden.via.length;k++){ if(isAllowed(x.val,wadden.via[k].ring)){ wMatched[k]=true; break; } }
      });
      wUnmatched=wadden.via.filter(function(v,k){return !wMatched[k];}).map(function(v){return v.plaats;});
    }
    els.forEach(function(x){
      if(!isBezorg(x.val)) afhalen=x;
      var avail=!qtyDisabled(x), show;
      if(!avail) show=false;
      else if(!isBezorg(x.val)) show=true;
      else if(contact){ show=false; restoreLabel(x); }
      else if(wadden){
        var via=null;
        if(isSpecificZone(x.val)){ for(var k=0;k<wadden.via.length;k++){ if(isAllowed(x.val,wadden.via[k].ring)){ via=wadden.via[k]; break; } } }
        if(via){ show=true; relabel(x,"Bezorgen naar "+via.plaats); }
        else if(!isSpecificZone(x.val) && wUnmatched.length){ show=true; relabel(x,"Bezorgen naar "+wUnmatched.join(" of ")); }
        else { show=false; restoreLabel(x); }
      }
      else if(!hasPc) show=false;
      else if(isSpecificZone(x.val)) show=isAllowed(x.val,r);
      else show=!hasSpecificZone;
      if(!wadden && isBezorg(x.val)) restoreLabel(x);
      if(afhMode && isBezorg(x.val)) show=false;          /* v36: afhalen gekozen -> geen bezorgopties */
      if(bezMode && !isBezorg(x.val)) show=false;         /* v36: bezorgen gekozen -> Afhalen-knop weg (blijft kiesbaar in het blok bovenaan) */
      setVisible(x,show);
      if(show && isBezorg(x.val)) shownBezorg.push(x);
      if(!show && isSelected(x) && isBezorg(x.val)) needReselect=true;
    });
    var pickupOnly = bezMode ? false : (isPickupOnlyQty() || afhMode);
    var bezAvail = els.some(function(x){ return x.kind==="radio" && isBezorg(x.val) && !qtyDisabled(x); });
    if(pickupOnly && afhalen && !isSelected(afhalen)) needReselect=true;
    /* v35: Afhalen staat nog gekozen maar bestaat niet voor dit aantal (35/50/60 zakken) en er is precies één bezorgoptie zichtbaar -> die kiezen */
    var afhR=els.filter(function(x){ return x.kind==="radio" && !isBezorg(x.val); })[0] || afhalen;
    var bzR=shownBezorg.filter(function(x){ return x.kind==="radio"; }); if(!bzR.length) bzR=shownBezorg;
    var kiesBezorg = !pickupOnly && afhR && isSelected(afhR) && (qtyDisabled(afhR) || bezMode) && bzR.length===1;
    if(kiesBezorg) needReselect=true;
    if(needReselect && !applying){
      applying=true;
      var target=pickupOnly ? (afhR||afhalen) : (kiesBezorg ? bzR[0] : (shownBezorg[0]||(bezMode?null:afhalen)));
      if(target) selectEl(target);
      setTimeout(function(){applying=false;},50);
    } else if(needReselect && applying){ retryApply(); } /* v39 */
    var box=document.getElementById("epk-postcode-box");
    if(box) box.style.display = (pickupOnly || (bezMode && !bezAvail)) ? "none" : "";
    /* v31: de zin "Bezorgkosten zitten al in de prijs…" alleen tonen als een bezorgoptie is gekozen */
    try{
      var levSel=null; els.forEach(function(x){ if(x.kind==="radio" && isSelected(x)) levSel=x.val; });
      var bezorgGekozen = !!(levSel && isBezorg(levSel));
      document.querySelectorAll(".product__tax").forEach(function(tax){
        var sp=tax.querySelector(".epk-bezorgtekst");
        if(!sp){ sp=document.createElement("span"); sp.className="epk-bezorgtekst"; sp.textContent=" Bezorgkosten zitten al in de prijs, dus geen verrassingen bij het afrekenen."; tax.appendChild(sp); }
        sp.style.display = bezorgGekozen ? "" : "none";
      });
    }catch(e){}
    var lgd=null;
    for(var q=0;q<els.length;q++){
      var e=els[q].kind==="radio"?els[q].el:els[q].el.parentElement;
      var fs=(e&&e.closest)?(e.closest("fieldset")||e.closest(".product-form__input")):null;
      if(fs){ lgd=fs.querySelector("legend")||fs.querySelector(".form__label"); if(lgd) break; }
    }
    if(lgd){
      var showDist = shownBezorg.length>0 && !wadden && !contact;
      lgd.style.display = showDist ? "" : "none";
    }
    if(useMode){ var fsLev=afhR&&afhR.el.closest?afhR.el.closest("fieldset"):null; if(fsLev) fsLev.style.display = afhMode ? "none" : ""; }
    /* v35: aantal zonder afhaalvariant en nog geen postcode -> geen "Niet beschikbaar" maar vragen om de postcode */
    var afhAvail = !!(afhR && !qtyDisabled(afhR));
    var needPc = !pickupOnly && !hasPc && !afhAvail && els.some(function(x){ return isBezorg(x.val) && !qtyDisabled(x); });
    var blocked=needPc, blockTxt=NEED_TXT;
    if(bezMode){
      var selLev=null; els.forEach(function(x){ if(x.kind==="radio" && isSelected(x)) selLev=x; });
      var levOk = !!(selLev && isBezorg(selLev.val) && isShown(selLev) && !qtyDisabled(selLev));
      blocked = !levOk;
      needPc = blocked && !hasPc;
      blockTxt = !hasPc ? NEED_TXT : (contact ? "Bezorging op aanvraag" : (bzR.length>1 ? "Kies hieronder de plaats" : ""));
      if(!bezAvail){ needPc=false; blockTxt=(window.variantStrings&&window.variantStrings.soldOut)||"Uitverkocht"; }
      /* v39: postcode bekend, precies één bezorgoptie zichtbaar, maar die staat (nog) niet gekozen -> alsnog kiezen */
      if(blocked && hasPc && bezAvail && !contact && bzR.length===1 && bzR[0].kind==="radio" && !qtyDisabled(bzR[0])){
        if(!applying){ applying=true; selectEl(bzR[0]); setTimeout(function(){applying=false;},50); }
        retryApply();
      }
    }
    markNeedPc(blocked, blockTxt, needPc);
    if(msg){
      if(contact){
        msg.innerHTML = "📍 <strong>"+contact.naam+"</strong>: bezorging hierheen regelen we op aanvraag. Neem contact op via <a href=\"tel:0518451273\">0518-451273</a> of <a href=\"mailto:info@elitepelletskopen.nl\">info@elitepelletskopen.nl</a>. Afhalen kan gewoon.";
      }
      else if(wadden){
        var pl=wadden.via.map(function(v){return v.plaats;});
        var plTxt = pl.length>1 ? pl.slice(0,-1).join(", ")+" of "+pl[pl.length-1] : pl[0];
        msg.innerHTML = "📍 <strong>"+wadden.naam+"</strong>: bezorging gaat naar <strong>"+plTxt+"</strong> (vasteland)."+(pl.length>1?" Kies hieronder de plaats.":"");
      }
      else if(hasPc) msg.innerHTML = "✓ Bezorging afgestemd op je postcode.";
      else if(needPc && bezMode) msg.innerHTML = "🚚 Vul je postcode in. Dan zie je de bezorgprijs voor jouw adres.";
      else if(needPc) msg.innerHTML = "🚚 Dit aantal wordt bezorgd. Vul je postcode in om te bestellen.";
      else msg.innerHTML = "🚚 Afhalen kan zonder postcode.";
    }
    if(hasPc) scheduleAutoSelect();
  }

  /* v28: zodra een volledige postcode (4 cijfers) is ingevoerd en Afhalen nog geselecteerd staat, wordt de (enige) zichtbare
     bezorgoptie automatisch gekozen. Niet bij 1 zak/10 zakken (alleen afhalen), niet bij contact-zones, niet bij meerdere
     bezorgopties (Wadden-keuze: klant kiest zelf). Eén keer per postcode: kiest de klant daarna bewust Afhalen, blijft dat zo. */
  var lastAutoPc="", autoTimer=null, userActed=false;
  /* v29: pas na een eigen handeling van de klant op de productpagina (aantal kiezen, postcode typen); nooit bij het laden. */
  document.addEventListener("change",function(e){ var t=e.target; if(t && t.closest && t.closest('product-info, form[action*="/cart/add"]')) userActed=true; },true);
  /* v36: keuze afhalen/bezorgen bovenaan bepaalt de zichtbare aantallen */
  var mode=null, selCount=0;
  function variantTitels(){
    var out=[];
    if(prodData){ prodData.variants.forEach(function(v){ out.push([v.option1||"", v.option2||""]); }); return out; }
    try{ var vs=window.ShopifyAnalytics.meta.product.variants; vs.forEach(function(v){ var p=(v.public_title||"").split(" / "); if(p.length>=2) out.push([p[0].trim(), p.slice(1).join(" / ").trim()]); }); }catch(e){}
    return out;
  }
  function qtyRadios(){ var out=[]; document.querySelectorAll('input[type="radio"][name*="Hoeveelheid"]').forEach(function(i){ if(!isStale(i)) out.push({kind:"radio",el:i,val:(i.value||"").trim()}); }); return out; }
  function qtyAllowed(q){
    var vt=variantTitels(); if(!vt.length || !mode) return true;
    var bez=(mode==="bezorgen");
    return vt.some(function(p){ return p[0]===q && isBezorg(p[1])===bez; });
  }
  function filterQty(){ qtyRadios().forEach(function(x){ setVisible(x, qtyAllowed(x.val)); }); }
  function modeFromSelection(els){ var b=false; els.forEach(function(x){ if(x.kind==="radio" && isSelected(x) && isBezorg(x.val)) b=true; }); return b?"bezorgen":"afhalen"; }
  function ensureModeUI(els){
    var hasB=els.some(function(x){ return x.kind==="radio" && isBezorg(x.val); }), hasA=els.some(function(x){ return x.kind==="radio" && !isBezorg(x.val); });
    if(!hasB || !hasA) return false;
    var box=document.getElementById("epk-mode-box");
    if(!box){
      var vs=null; document.querySelectorAll("product-info variant-selects").forEach(function(v){ if(!vs && v.style.display!=="none") vs=v; });
      if(!vs || !vs.parentNode) return false;
      box=document.createElement("fieldset"); box.id="epk-mode-box"; box.className="js product-form__input product-form__input--pill";
      box.innerHTML='<legend class="form__label">Hoe wil je je pellets ontvangen?</legend>'+
        '<input type="radio" id="epk-mode-a" name="epk-ontvangen" value="pickup"><label for="epk-mode-a">Afhalen in Menaam</label>'+
        '<input type="radio" id="epk-mode-b" name="epk-ontvangen" value="delivery"><label for="epk-mode-b">Laten bezorgen</label>';
      vs.parentNode.insertBefore(box,vs);
      box.addEventListener("change",function(e){ var t=e.target; if(t && t.name==="epk-ontvangen"){ e.stopPropagation(); onModeChange(t.value==="delivery"?"bezorgen":"afhalen"); } });
    }
    if(mode===null) mode=modeFromSelection(els);
    var a=document.getElementById("epk-mode-a"), b=document.getElementById("epk-mode-b");
    if(prodData && b){
      /* geen enkele bezorgvariant leverbaar -> "Laten bezorgen" niet kiesbaar */
      var bA=prodData.variants.some(function(v){ return v.available && isBezorg(v.option2||""); });
      var lb=box.querySelector('label[for="epk-mode-b"]'), want=bA?"Laten bezorgen":"Laten bezorgen (uitverkocht)";
      if(b.disabled!==!bA) b.disabled=!bA;
      b.classList.toggle("disabled",!bA);
      if(lb && lb.textContent!==want) lb.textContent=want;
      if(!bA && mode==="bezorgen") mode="afhalen";
    }
    if(a && b){ if(a.checked!==(mode==="afhalen")) a.checked=(mode==="afhalen"); if(b.checked!==(mode==="bezorgen")) b.checked=(mode==="bezorgen"); }
    return true;
  }
  /* gekozen aantal past niet bij de keuze -> dichtstbijzijnde aantal dat wel past. Geeft true terug als er gewisseld is. */
  function fixQty(){
    var qs=qtyRadios(), cur=qs.filter(isSelected)[0];
    if(!cur || qtyAllowed(cur.val)) return false;
    var n=parseInt(cur.val,10)||0, best=null, bd=1e9;
    qs.forEach(function(x){ if(!qtyAllowed(x.val)) return; var dd=Math.abs((parseInt(x.val,10)||0)-n); if(dd<bd){ bd=dd; best=x; } });
    if(!best) return false;
    selCount++; applying=true; best.el.checked=true; best.el.dispatchEvent(new Event("change",{bubbles:true}));
    setTimeout(function(){ applying=false; apply(); },60);
    return true;
  }
  function onModeChange(m){
    if(mode===m) return;
    mode=m; userActed=true; lastAutoPc="";
    var before=selCount;
    apply();
    if(selCount===before){ var c=qtyRadios().filter(isSelected)[0]; if(c) c.el.dispatchEvent(new Event("change",{bubbles:true})); }
  }
  /* v35 */
  var NEED_TXT="Vul eerst je postcode in", prodData=null, prodLoading=false;
  function fmtMoney(c){ return "\u20AC"+(c/100).toFixed(2).replace(".",","); }
  function loadProduct(){
    if(prodData||prodLoading) return; prodLoading=true;
    var m=location.pathname.match(/\/products\/[^\/]+/); if(!m) return;
    fetch(m[0]+".js",{credentials:"same-origin"}).then(function(r){ return r.ok?r.json():null; }).then(function(j){ if(j&&j.variants){ prodData=j; apply(); } }).catch(function(){});
  }
  function showQtyPrice(){
    if(!prodData){ loadProduct(); return; }
    var q=selectedHoeveelheid(); if(!q) return;
    var ps=prodData.variants.filter(function(v){ return v.available && v.option1===q && isBezorg(v.option2||""); }).map(function(v){ return v.price; });
    if(!ps.length) return;
    var min=Math.min.apply(null,ps), max=Math.max.apply(null,ps);
    var txt=(min!==max?"Vanaf ":"")+fmtMoney(min);
    document.querySelectorAll('product-info [id^="price-"]').forEach(function(box){
      var it=box.querySelector(".price__regular .price-item--regular"); if(!it) return;
      if(it.textContent.trim()!==txt) it.textContent=txt;
      box.setAttribute("data-epk-prijs","1");
      box.classList.remove("hidden"); box.classList.remove("visibility-hidden");
      var pr=box.querySelector(".price"); if(pr){ pr.classList.remove("price--on-sale"); pr.classList.remove("price--sold-out"); }
    });
  }
  /* v36: blokkeert de bestelknop zolang er bij "Laten bezorgen" geen geldige bezorgoptie gekozen is. Herstel volgt de echte variant. */
  /* v37: foto van het gekozen aantal, ook als de gekozen combinatie (nog) niet bestaat.
     Het thema toont per variant alleen de eigen foto, dus de galerij van die variant wordt opgehaald en via het thema zelf (updateMedia) gezet. */
  var mediaHtml={}, mediaWant="";
  function showQtyMedia(){
    if(!prodData) return;
    var q=selectedHoeveelheid(); if(!q) return;
    var vs=prodData.variants.filter(function(v){ return v.option1===q && v.featured_media && isBezorg(v.option2||""); });
    if(!vs.length) vs=prodData.variants.filter(function(v){ return v.option1===q && v.featured_media; });
    if(!vs.length) return;
    var v=vs[0], mid=v.featured_media.id;
    document.querySelectorAll("product-info").forEach(function(pi){
      var mg=pi.querySelector("media-gallery"), sec=pi.dataset.section;
      if(!mg || !sec || typeof pi.updateMedia!=="function") return;
      var key=sec+"-"+mid, el=mg.querySelector('[data-media-id="'+key+'"]');
      if(el && el.classList.contains("is-active") && el.parentElement.firstElementChild===el){ mediaWant=key; return; }
      if(mediaWant===key && mediaHtml[key]==="laden") return;
      mediaWant=key;
      var zet=function(txt){
        if(mediaWant!==key || !document.body.contains(pi)) return;
        var b=pi.querySelector(".product-form__submit"); if(!b || !b.getAttribute("data-epk-needpc")) return;
        try{ pi.updateMedia(new DOMParser().parseFromString(txt,"text/html"), mid); }catch(e){}
      };
      if(mediaHtml[key] && mediaHtml[key]!=="laden"){ zet(mediaHtml[key]); return; }
      mediaHtml[key]="laden";
      fetch(location.pathname+"?variant="+v.id+"&section_id="+encodeURIComponent(sec)).then(function(r){ return r.ok?r.text():""; }).then(function(txt){
        if(!txt){ delete mediaHtml[key]; return; }
        mediaHtml[key]=txt; zet(txt);
      }).catch(function(){ delete mediaHtml[key]; });
    });
  }
  function curVariant(){
    if(!prodData) return null;
    var q=selectedHoeveelheid(), l=null;
    deliveryEls().forEach(function(x){ if(x.kind==="radio" && isSelected(x)) l=x.val; });
    for(var i=0;i<prodData.variants.length;i++){ var v=prodData.variants[i]; if(v.option1===q && v.option2===l) return v; }
    return null;
  }
  /* v38: tik op "Vul eerst je postcode in" -> naar het postcodeveld, niet bestellen */
  function naarPostcode(b){
    var sc=(b.closest&&b.closest("product-info"))||document, f=sc.querySelector("#epk-pc")||document.getElementById("epk-pc"); if(!f) return;
    var box=(f.closest&&f.closest("#epk-postcode-box"))||f;
    try{ box.scrollIntoView({behavior:"smooth",block:"center"}); }catch(e){ box.scrollIntoView(); }
    setTimeout(function(){ try{ f.focus({preventScroll:true}); }catch(e){ f.focus(); } },500);
  }
  document.addEventListener("click",function(e){
    var b=e.target&&e.target.closest?e.target.closest(".product-form__submit[data-epk-scrollpc]"):null; if(!b) return;
    e.preventDefault(); e.stopImmediatePropagation(); naarPostcode(b);
  },true);
  document.addEventListener("submit",function(e){
    var f=e.target, b=f&&f.querySelector?f.querySelector(".product-form__submit[data-epk-scrollpc]"):null; if(!b) return;
    e.preventDefault(); e.stopImmediatePropagation(); naarPostcode(b);
  },true);
  function markNeedPc(on, txt, rand){
    var vsx=window.variantStrings||{};
    var f=document.getElementById("epk-pc");
    if(f){ f.style.border = (on && rand!==false) ? "2px solid rgb(224,97,28)" : "1px solid #ccc"; }
    document.querySelectorAll("product-info .product-form__submit").forEach(function(b){
      var sp=b.querySelector("span")||b;
      if(on){
        var t=txt||vsx.unavailable||"Niet beschikbaar";
        if(sp.textContent.trim()!==t) sp.textContent=t;
        if(rand===true){
          /* v38: klikbaar houden; een tik brengt de klant naar het postcodeveld */
          if(b.disabled) b.disabled=false;
          if(b.getAttribute("aria-disabled")!=="true") b.setAttribute("aria-disabled","true");
          if(!b.getAttribute("data-epk-scrollpc")) b.setAttribute("data-epk-scrollpc","1");
        } else {
          if(b.getAttribute("data-epk-scrollpc")){ b.removeAttribute("data-epk-scrollpc"); b.removeAttribute("aria-disabled"); }
          if(!b.disabled) b.disabled=true;
        }
        b.setAttribute("data-epk-needpc","1");
      }
      else if(b.getAttribute("data-epk-needpc")){
        b.removeAttribute("data-epk-needpc");
        if(b.getAttribute("data-epk-scrollpc")){ b.removeAttribute("data-epk-scrollpc"); b.removeAttribute("aria-disabled"); }
        var v=curVariant();
        if(prodData){
          b.disabled=!(v&&v.available);
          sp.textContent = !v ? (vsx.unavailable||"Niet beschikbaar") : (v.available ? (vsx.addToCart||"In winkelwagen") : (vsx.soldOut||"Uitverkocht"));
          document.querySelectorAll('product-info [id^="price-"]').forEach(function(box){
            if(!box.getAttribute("data-epk-prijs")) return; box.removeAttribute("data-epk-prijs");
            var it=box.querySelector(".price__regular .price-item--regular"); if(it && v) it.textContent=fmtMoney(v.price);
          });
        }
      }
    });
    if(on){ showQtyPrice(); showQtyMedia(); }
  }
  function isShown(x){ if(x.kind==="radio"){ var l=labelOf(x); return x.el.style.display!=="none" && (!l || l.style.display!=="none"); } return !x.el.disabled && x.el.style.display!=="none"; }
  var retryT=null, retryN=0;
  function retryApply(){ if(retryT) return; retryT=setTimeout(function(){ retryT=null; if(retryN++<6) apply(); setTimeout(function(){ retryN=0; },2000); },120); }
  function autoSelectBezorgen(){
    var pc=pcValue(); if(pc.length<4 || pc===lastAutoPc || !userActed) return;
    if(applying || isPickupOnlyQty() || contactOf(pc)) return; /* nog niet mogelijk; later opnieuw proberen */
    var els=deliveryEls();
    var afh=els.filter(function(x){ return x.kind==="radio" && !isBezorg(x.val); })[0] || els.filter(function(x){ return !isBezorg(x.val); })[0];
    if(!afh) return;
    if(!isSelected(afh)){ lastAutoPc=pc; return; } /* klant koos al zelf een bezorgoptie */
    var vis=els.filter(function(x){ return isBezorg(x.val) && !qtyDisabled(x) && isShown(x) && x.kind===afh.kind; });
    if(vis.length!==1){ lastAutoPc=pc; return; } /* meerdere opties (Wadden): klant kiest zelf */
    lastAutoPc=pc; applying=true; selectEl(vis[0]); setTimeout(function(){applying=false;},50);
  }
  function scheduleAutoSelect(){ if(autoTimer) clearTimeout(autoTimer); autoTimer=setTimeout(autoSelectBezorgen,350); }
  function onPcInput(){
    var el=document.getElementById("epk-pc");
    if(el) setSavedPc(el.value);
    userActed=true;
    apply();
    scheduleAutoSelect();
  }

  function injectUI(){
    if(document.getElementById("epk-postcode-box")) return;
    var els=deliveryEls();
    if(!els.some(function(x){return isBezorg(x.val);})) return;
    var form=getForm(); if(!form) return;
    var box=document.createElement("div");
    box.id="epk-postcode-box";
    box.style.cssText="margin:12px 0;padding:12px;border:1px solid #ddd;border-radius:8px;";
    box.innerHTML='<label for="epk-pc" style="display:block;font-weight:600;margin-bottom:6px;">Vul hier je postcode in (voor bezorging)</label>'+
      '<form id="epk-pc-form" autocomplete="on" novalidate style="margin:0;"><input id="epk-pc" name="postal-code" type="text" inputmode="numeric" autocomplete="section-epk postal-code" autocorrect="off" autocapitalize="off" spellcheck="false" maxlength="7" placeholder="bv. 9036" style="padding:8px;width:150px;border:1px solid #ccc;border-radius:6px;font-size:16px;"></form>'+
      '<div id="epk-postcode-msg" style="margin-top:8px;font-size:14px;line-height:1.4;"></div>';
    var bz=els.filter(function(x){return isBezorg(x.val);})[0];
    var fs=(bz&&bz.el.closest)?bz.el.closest("fieldset"):null;
    if(fs&&fs.parentNode) fs.parentNode.insertBefore(box,fs); else form.prepend(box);
    var field=document.getElementById("epk-pc");
    if(savedPc) field.value=savedPc;
    var pcForm=document.getElementById("epk-pc-form"); if(pcForm) pcForm.addEventListener("submit",function(e){ e.preventDefault(); field.blur(); });
    var prevLen=(field.value||"").replace(/[^0-9]/g,"").length;
    field.addEventListener("input", function(){
      var nowLen=(field.value||"").replace(/[^0-9]/g,"").length, jump=nowLen-prevLen; prevLen=nowLen;
      onPcInput();
    });
  }
  function inScope(n){ return !!(n && n.closest && n.closest('product-info, variant-selects, form[action*="/cart/add"], .product')); }
  function relevant(recs){
    for(var i=0;i<recs.length;i++){
      var r=recs[i]; if(inScope(r.target)) return true;
      for(var k=0;k<r.addedNodes.length;k++){ var n=r.addedNodes[k]; if(n.nodeType!==1) continue; if(inScope(n)||(n.matches&&n.matches("product-info,variant-selects,form"))||(n.querySelector&&n.querySelector('input[type="radio"],form[action*="/cart/add"]'))) return true; }
    }
    return false;
  }
  var mo;
  function boot(){
    loadProduct();
    injectUI(); apply();
    mo=new MutationObserver(function(recs){
      if(!relevant(recs)) return;
      injectUI(); apply();
      mo.takeRecords(); /* eigen DOM-wijzigingen niet opnieuw verwerken */
    });
    mo.observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",boot); else boot();
})();